export default "__VITE_PUBLIC_ASSET__56fad4c6__"